import $ from "jquery";
import {active} from "./const.js";

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".js-truncateText").forEach(element => {
    const maxLength = element.getAttribute("data-truncate");

    if (!maxLength) return; // data-truncate がない場合は処理しない

    const maxLengthNum = parseInt(maxLength, 10);
    const fullText = element.textContent.trim();

    if (fullText.length > maxLengthNum) {
      const truncatedText = fullText.slice(0, maxLengthNum) + "… ";
      const readMoreSpan = document.createElement("span");
      readMoreSpan.textContent = " 続きを読む";

      element.innerHTML = truncatedText;
      element.appendChild(readMoreSpan);
    }
  });
});
